import styled from "styled-components";

const Heading = styled.div`
  margin-bottom: 4px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
`;
export default Heading;
